<template>
  <div>
    <top-bar mode="Admin"/>
    <router-view></router-view>
    <LoginDialog mode="Admin"/>
  </div>
</template>

<script>
import TopBar from '@/components/base/TopBar'
import LoginDialog from '@/components/authentication/LoginDialog'
import { mapActions } from 'vuex'

export default {
  components: { TopBar, LoginDialog },
  name: 'admin-home-layout',

  methods: {
    ...mapActions('auth', ['activeCheckSession', 'stopCheckSession'])
  },

  mounted () {
    this.activeCheckSession()
  },

  beforeDestroy () {
    this.stopCheckSession()
  }
}
</script>
